import { createSlice } from "@reduxjs/toolkit";

const initialState = {

  }

const consultantSlice = createSlice({
    name: 'consultant',
    initialState,
    reducers: {},
})

export const {} = consultantSlice.actions

export default consultantSlice.reducer;